import type { I18nT } from '@runtime/core/i18n/i18n'
import type { ThemeIndexItem } from '@runtime/features/poster/logic/posterTheme.types'
import PosterThemeCard from '@runtime/features/poster/components/PosterThemeCard'
import PosterThemeStatus from '@runtime/features/poster/components/PosterThemeStatus'
import styles from '@runtime/features/poster/components/PosterThemeGrid.module.scss'

type PosterThemeGridProps = {
  t: I18nT
  activeId: string
  list: ThemeIndexItem[]
  visibleList: ThemeIndexItem[]
  loadedMap: Record<string, boolean>
  loading: boolean
  applying: boolean
  isPrivateVisible: (id: string) => boolean
  markLoaded: (id: string) => void
  onPick: (item: ThemeIndexItem) => void
}

export default function PosterThemeGrid({
  t,
  activeId,
  list,
  visibleList,
  loadedMap,
  loading,
  applying,
  isPrivateVisible,
  markLoaded,
  onPick,
}: PosterThemeGridProps) {
  return (
    <section className={styles.themeGrid}>
      {applying ? (
        <PosterThemeStatus message={t('posterModal.loading')} overlay />
      ) : null}

      <div id="usposter-grid" className={styles.grid}>
        {visibleList.map((item) => {
          return (
            <PosterThemeCard
              key={item.id}
              item={item}
              selected={item.id === activeId}
              loaded={!!loadedMap[item.id]}
              showPrivateBadge={isPrivateVisible(item.id)}
              t={t}
              markLoaded={markLoaded}
              onPick={onPick}
            />
          )
        })}
      </div>

      {loading && !list.length ? (
        <PosterThemeStatus message={t('posterModal.loadingList')} />
      ) : null}

      {!loading && !visibleList.length ? (
        <p className={styles.emptyState}>{t('posterModal.empty')}</p>
      ) : null}
    </section>
  )
}
